'use client'

/**
 * The one place a plan action reports that it did not happen.
 *
 * Its own module so it can be mounted and read in a test: the claim being
 * made is "the customer sees this", and a regex over the parent's source
 * cannot reach that claim. Importing the dialog itself pulls in posthog-js
 * and a custom-element registration, neither of which a jsdom render of one
 * paragraph should have to satisfy.
 *
 * `role="alert"` because the button the customer just pressed sits in the grid
 * BELOW this band — on a short viewport the feedback for their click can land
 * off-screen, and a silent <p> is then indistinguishable from the dead button
 * this replaced.
 */
export function PlanNotice({ message }: { message: string | null }) {
  if (!message) return null
  return (
    <p
      role="alert"
      data-testid="plan-notice"
      className="rounded-lg bg-red-50 dark:bg-red-950/40 px-3 py-2 text-center text-sm text-red-700 dark:text-red-300"
    >
      {message}
    </p>
  )
}
